module.exports = __webpack_public_path__ + "static/media/15.8d222a2f.jpg";